import { render, staticRenderFns } from "./ParametricRootFolderCard.vue?vue&type=template&id=28c45ba7&scoped=true&"
import script from "./ParametricRootFolderCard.vue?vue&type=script&lang=js&"
export * from "./ParametricRootFolderCard.vue?vue&type=script&lang=js&"
import style0 from "./ParametricRootFolderCard.vue?vue&type=style&index=0&id=28c45ba7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c45ba7",
  null
  
)

export default component.exports